import React from "react";
import {withTranslation} from "react-i18next";
import Utils from "../../../../../../../utils/Utils";
import CheckBoxTable from "./CheckBoxTable";


class DiagnosiEseguitaNeisseriaMIB extends React.Component {

    state = {
        diagnosiNeisseria: {
            liquor: this.props.statePadre && this.props.statePadre.liquor ? this.props.statePadre.liquor : false,
            sangue: this.props.statePadre && this.props.statePadre.sangue ? this.props.statePadre.sangue : false,
            liquidoPleurico: this.props.statePadre && this.props.statePadre.liquidoPleurico ? this.props.statePadre.liquidoPleurico : false,
            liquidoPeritoneale: this.props.statePadre && this.props.statePadre.liquidoPeritoneale ? this.props.statePadre.liquidoPeritoneale : false,
            liquidoPericardio: this.props.statePadre && this.props.statePadre.liquidoPericardio ? this.props.statePadre.liquidoPericardio : false,
            liquidoSinoviale: this.props.statePadre && this.props.statePadre.liquidoSinoviale ? this.props.statePadre.liquidoSinoviale : false,
            placenta: this.props.statePadre && this.props.statePadre.placenta ? this.props.statePadre.placenta : false,
            patecchie: this.props.statePadre && this.props.statePadre.patecchie ? this.props.statePadre.patecchie : false,
            materiale: this.props.statePadre && this.props.statePadre.materiale ? this.props.statePadre.materiale : false,

            coltura1_Liquor1: this.props.statePadre && this.props.statePadre.coltura1_Liquor1 ? this.props.statePadre.coltura1_Liquor1 : false,
            coltura2_Sangue2: this.props.statePadre && this.props.statePadre.coltura2_Sangue2 ? this.props.statePadre.coltura2_Sangue2 : false,
            coltura3_Plueurico3: this.props.statePadre && this.props.statePadre.coltura3_Plueurico3 ? this.props.statePadre.coltura3_Plueurico3 : false,
            coltura4_Peritoneale4: this.props.statePadre && this.props.statePadre.coltura4_Peritoneale4 ? this.props.statePadre.coltura4_Peritoneale4 : false,
            coltura5_Pericardio5: this.props.statePadre && this.props.statePadre.coltura5_Pericardio5 ? this.props.statePadre.coltura5_Pericardio5 : false,
            coltura6_Sinoviale6: this.props.statePadre && this.props.statePadre.coltura6_Sinoviale6 ? this.props.statePadre.coltura6_Sinoviale6 : false,
            coltura7_Placenta7: this.props.statePadre && this.props.statePadre.coltura7_Placenta7 ? this.props.statePadre.coltura7_Placenta7 : false,
            coltura8_Patecchie8: this.props.statePadre && this.props.statePadre.coltura8_Patecchie8 ? this.props.statePadre.coltura8_Patecchie8 : false,
            coltura9_Materiale9: this.props.statePadre && this.props.statePadre.coltura9_Materiale9 ? this.props.statePadre.coltura9_Materiale9 : false,
            ricerca1_Liquor1: this.props.statePadre && this.props.statePadre.ricerca1_Liquor1 ? this.props.statePadre.ricerca1_Liquor1 : false,
            pcr1_Liquor1: this.props.statePadre && this.props.statePadre.pcr1_Liquor1 ? this.props.statePadre.pcr1_Liquor1 : false,
            pcr2_Sangue2: this.props.statePadre && this.props.statePadre.pcr2_Sangue2 ? this.props.statePadre.pcr2_Sangue2 : false,
            pcr3_Plueurico3: this.props.statePadre && this.props.statePadre.pcr3_Plueurico3 ? this.props.statePadre.pcr3_Plueurico3 : false,
            pcr4_Peritoneale4: this.props.statePadre && this.props.statePadre.pcr4_Peritoneale4 ? this.props.statePadre.pcr4_Peritoneale4 : false,
            pcr5_Pericardio5: this.props.statePadre && this.props.statePadre.pcr5_Pericardio5 ? this.props.statePadre.pcr5_Pericardio5 : false,
            pcr6_Sinoviale6: this.props.statePadre && this.props.statePadre.pcr6_Sinoviale6 ? this.props.statePadre.pcr6_Sinoviale6 : false,
            pcr7_Placenta7: this.props.statePadre && this.props.statePadre.pcr7_Placenta7 ? this.props.statePadre.pcr7_Placenta7 : false,
            pcr8_Patecchie8: this.props.statePadre && this.props.statePadre.pcr8_Patecchie8 ? this.props.statePadre.pcr8_Patecchie8 : false,
            pcr9_Materiale9: this.props.statePadre && this.props.statePadre.pcr9_Materiale9 ? this.props.statePadre.pcr9_Materiale9 : false,
            esame1_Liquor1: this.props.statePadre && this.props.statePadre.esame1_Liquor1 ? this.props.statePadre.esame1_Liquor1 : false,

            corretto: []
        },
        malattiaBatterica_Neisseria: "",
        id_Neisseria: "",
        rowList_Neisseria: [],
        row_Neisseria: 0
    }

    constructor(props) {
        super(props)

        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.setStateGenerico = this.setStateGenerico.bind(this)

    }

    componentDidMount() {

        this.setState({malattiaBatterica_Neisseria: this.props.malattiaBatterica})
        let oggetto = this.createOggettoBE()
        let diagnosiNeisseria = this.state.diagnosiNeisseria
        this.props.setDiagnosiNeisseria(this.state.diagnosiNeisseria, oggetto)

        let statePadre = JSON.parse(JSON.stringify(this.props.statePadre))
        delete statePadre["corretto"];

        if(Utils.isEmpty(statePadre)) {
            if (this.props.malattiaBatterica !== "malattiaBatterica1") {
                diagnosiNeisseria.corretto = []
                this.setState({diagnosiNeisseria: diagnosiNeisseria})
            } else if (this.props.malattiaBatterica === "malattiaBatterica1") {
                if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.diagnosiNeisseria) {
                    diagnosiNeisseria = this.state.diagnosiNeisseria
                    let diagnosiNeisseriaProps = this.props.segnalazioneCopia.schedaSpeciale.diagnosiNeisseria

                    for (let key in diagnosiNeisseria) {
                        if (diagnosiNeisseria.hasOwnProperty(key) === diagnosiNeisseriaProps.hasOwnProperty(key)) {
                            diagnosiNeisseria[key] = diagnosiNeisseriaProps[key]
                        } else {
                            diagnosiNeisseria[key] = false
                        }
                    }

                    this.setState({diagnosiNeisseria: diagnosiNeisseria});

                }
            }
        }

        this.controlloDati()
            oggetto = this.createOggettoBE()
            this.props.setDiagnosiNeisseria(this.state.diagnosiNeisseria, oggetto)

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.malattiaBatterica != this.props.malattiaBatterica) {

            if (this.props.malattiaBatterica !== "malattiaBatterica1") {
                let diagnosiNeisseria = this.state.diagnosiNeisseria

                for (let key in diagnosiNeisseria) {
                    diagnosiNeisseria[key] = false
                }

                // diagnosiNeisseria.corretto = true

                this.setState({
                    diagnosiNeisseria: diagnosiNeisseria,
                    malattiaBatterica_Neisseria: this.props.malattiaBatterica
                })
                let oggetto = this.createOggettoBE()
                this.props.setDiagnosiNeisseria(this.state.diagnosiNeisseria, oggetto)
            } else {
                this.setState({malattiaBatterica_Neisseria: this.props.malattiaBatterica})
                this.controlloDati()
                let oggetto = this.createOggettoBE()
                this.props.setDiagnosiNeisseria(this.state.diagnosiNeisseria, oggetto)
            }
        }
    }

    createOggettoBE() {
        let diagnosiNeisseria = JSON.parse(JSON.stringify(this.state.diagnosiNeisseria))
        let diagnosiNeisseriaBe = Utils.removeEmptyValueFromObject(diagnosiNeisseria)
        return Utils.removeFieldFromObject(diagnosiNeisseriaBe, "corretto")

    }

    controlloDati() {
        let diagnosiNeisseria = this.state.diagnosiNeisseria
        diagnosiNeisseria.corretto = []

        if (!(
            diagnosiNeisseria.liquor && (diagnosiNeisseria.coltura1_Liquor1 || diagnosiNeisseria.ricerca1_Liquor1 || diagnosiNeisseria.pcr1_Liquor1 || diagnosiNeisseria.esame1_Liquor1) ||
            diagnosiNeisseria.sangue && (diagnosiNeisseria.coltura2_Sangue2 || diagnosiNeisseria.pcr2_Sangue2) ||
            diagnosiNeisseria.liquidoPleurico && (diagnosiNeisseria.coltura3_Plueurico3 || diagnosiNeisseria.pcr3_Plueurico3) ||
            diagnosiNeisseria.liquidoPeritoneale && (diagnosiNeisseria.coltura4_Peritoneale4 || diagnosiNeisseria.pcr4_Peritoneale4) ||
            diagnosiNeisseria.liquidoPericardio && (diagnosiNeisseria.coltura5_Pericardio5 || diagnosiNeisseria.pcr5_Pericardio5) ||
            diagnosiNeisseria.liquidoSinoviale && (diagnosiNeisseria.coltura6_Sinoviale6 || diagnosiNeisseria.pcr6_Sinoviale6) ||
            diagnosiNeisseria.placenta && (diagnosiNeisseria.coltura7_Placenta7 || diagnosiNeisseria.pcr7_Placenta7) ||
            diagnosiNeisseria.patecchie && (diagnosiNeisseria.coltura8_Patecchie8 || diagnosiNeisseria.pcr8_Patecchie8) ||
            diagnosiNeisseria.materiale && (diagnosiNeisseria.coltura9_Materiale9 || diagnosiNeisseria.pcr9_Materiale9))) {
            diagnosiNeisseria.corretto[0] = "Campo \"Meningococco (N. Meningitidis)\" mancante o errato";
        }

        this.setState({diagnosiNeisseria: diagnosiNeisseria})
    }

    setStateGenerico(object) {
        this.setState(object)
        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setDiagnosiNeisseria(this.state.diagnosiNeisseria, oggetto)
    }

    render() {


        let disabled = this.props.malattiaBatterica && this.props.malattiaBatterica != "malattiaBatterica1" ? true : false
        let rows_Neisseria = [
            {
                check1Liquor1_Neisseria1: {
                    id: "liquor",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.1",
                    radio: false,
                    field: "liquor",
                    numeroCol: 1,
                    row: 1
                },
                check2Liquor1_Neisseria1: {
                    id: "coltura1_Liquor1",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "coltura1_Liquor",
                    numeroCol: 2,
                    row: 1
                },
                check3Liquor1_Neisseria1: {
                    id: "ricerca1_Liquor1",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.11",
                    radio: true,
                    field: "ricerca1_Liquor",
                    numeroCol: 3,
                    row: 1
                },
                check4Liquor1_Neisseria1: {
                    id: "pcr1_Liquor1",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcr1_Liquor",
                    numeroCol: 4,
                    row: 1
                },
                check5Liquor1_Neisseria1: {
                    id: "esame1_Liquor1",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.13",
                    radio: true,
                    field: "esame1_Liquor",
                    numeroCol: 5,
                    row: 1
                },
            },
            {
                check1Sangue1_Neisseria1: {
                    id: "sangue",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.2",
                    radio: false,
                    field: "sangue",
                    numeroCol: 1,
                    row: 2
                },
                check1Sangue2_Neisseria2: {
                    id: "coltura2_Sangue2",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "coltura2_Sangue",
                    numeroCol: 2,
                    row: 2
                },
                check1Sangue3_Neisseria3: {
                    id: "pcr2_Sangue2",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcr2_Sangue",
                    numeroCol: 4,
                    row: 2
                }
            },
            {
                check1Pleurico1_Neisseria1: {
                    id: "liquidoPleurico",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.3",
                    radio: false,
                    field: "liquidoPleurico",
                    numeroCol: 1,
                    row: 3
                },
                check1Pleurico2_Neisseria2: {
                    id: "coltura3_Plueurico3",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "coltura3_Plueurico",
                    numeroCol: 2,
                    row: 3
                },
                check1Pleurico3_Neisseria3: {
                    id: "pcr3_Plueurico3",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcr3_Plueurico",
                    numeroCol: 4,
                    row: 3
                }
            },
            {
                check1Peritoneale1_Neisseria1: {
                    id: "liquidoPeritoneale",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.4",
                    radio: false,
                    field: "liquidoPeritoneale",
                    numeroCol: 1,
                    row: 4
                },
                check1Peritoneale2_Neisseria2: {
                    id: "coltura4_Peritoneale4",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "coltura4_Peritoneale",
                    numeroCol: 2,
                    row: 4
                },
                check1Peritoneale3_Neisseria3: {
                    id: "pcr4_Peritoneale4",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcr4_Peritoneale",
                    numeroCol: 4,
                    row: 4
                }
            },
            {
                check1Pericardio1_Neisseria1: {
                    id: "liquidoPericardio",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.5",
                    radio: false,
                    field: "liquidoPericardio",
                    numeroCol: 1,
                    row: 5
                },
                check1Pericardio2_Neisseria2: {
                    id: "coltura5_Pericardio5",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "coltura5_Pericardio",
                    numeroCol: 2,
                    row: 5
                },
                check1Pericardio3_Neisseria3: {
                    id: "pcr5_Pericardio5",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcr5_Pericardio",
                    numeroCol: 4,
                    row: 5
                }
            },
            {
                check1Sinoviale1_Neisseria1: {
                    id: "liquidoSinoviale",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.8",
                    radio: false,
                    field: "liquidoSinoviale",
                    numeroCol: 1,
                    row: 6
                },
                check1Sinoviale2_Neiseria2: {
                    id: "coltura6_Sinoviale6",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "coltura6_Sinoviale",
                    numeroCol: 2,
                    row: 6
                },
                check1Sinoviale3_Neisseria3: {
                    id: "pcr6_Sinoviale6",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcr6_Sinoviale",
                    numeroCol: 4,
                    row: 6
                }
            },
            {
                check1Placenta1_Neisseria1: {
                    id: "placenta",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.6",
                    radio: false,
                    field: "placenta",
                    numeroCol: 1,
                    row: 7
                },
                check1Placenta2_Neisseria2: {
                    id: "coltura7_Placenta7",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "coltura7_Placenta",
                    numeroCol: 2,
                    row: 7
                },
                check1Placenta3_Neisseria3: {
                    id: "pcr7_Placenta7",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcr7_Placenta",
                    numeroCol: 4,
                    row: 7
                }
            },
            {
                check1Patecchie1_Neisseria1: {
                    id: "patecchie",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.7",
                    radio: false,
                    field: "patecchie",
                    numeroCol: 1,
                    row: 8
                },
                check1Patecchie2_Neisseria2: {
                    id: "coltura8_Patecchie8",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "coltura8_Patecchie",
                    numeroCol: 2,
                    row: 8
                },
                check1Patecchie3_Neisseria3: {
                    id: "pcr8_Patecchie8",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcr8_Patecchie",
                    numeroCol: 4,
                    row: 8
                }
            },
            {
                check1Materiale1_Materiale1: {
                    id: "materiale",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.9",
                    radio: false,
                    field: "materiale",
                    numeroCol: 1,
                    row: 9
                },
                check1Materiale2_Materiale2: {
                    id: "coltura9_Materiale9",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "coltura9_Materiale",
                    numeroCol: 2,
                    row: 9
                },
                check1Materiale3_Materiale3: {
                    id: "pcr9_Materiale9",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcr9_Materiale",
                    numeroCol: 4,
                    row: 9
                }
            }
        ]

        return (
            <div>
                <fieldset disabled={this.props.malattiaBatterica != "malattiaBatterica1"}>
                    <CheckBoxTable tipoMalattiaBattareica={"malattiaBatterica1"}
                                   intestazione={"SchedaFlussoSpeciale.MIB.DiagnosiEseguita.titolo1"}
                                   malattiaBatterica={this.props.malattiaBatterica ? this.props.malattiaBatterica : ""}
                                   stato={this.state.diagnosiNeisseria}
                                   disabled={disabled} rows={rows_Neisseria} rowList={this.state.rowList_Neisseria}
                                   setStatePadre={this.setStateGenerico} id={this.state.id_Neisseria}
                                   row={this.state.row_Neisseria}/>
                </fieldset>
            </div>

        )
    }
}

export default withTranslation('common')(DiagnosiEseguitaNeisseriaMIB)
